import * as actionTypes from '../actionTypes';

const initialState = {
	documents: [],
};

function reducer(state = initialState, action) {
	switch (action.type) {
		case actionTypes.SET_DOCUMENTS:
			return {
				...state,
				documents: action.payload
			};
		default:
			return state;
	}
}


export default reducer;
